import { Color, getDefaultTransition, sizeToDimension, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { Themable } from '../../../../../types/themable'

interface PeriodsListWrapperProps {
  disabled?: boolean
}

export const PeriodsListWrapper = styled.div<PeriodsListWrapperProps>`
  display: flex;
  opacity: ${({ disabled }) => (disabled ? 0.2 : 1)};
  flex-direction: column;
  min-height: 192px; /* needed to keep dropdown height while switching between tabs (preparing list can take some miliseconds which causes blinking) */
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`

interface PeriodItemsListProps {
  columns?: number
}

export const PeriodItemsList = styled.ul<PeriodItemsListProps>`
  display: grid;
  gap: ${Spacing.S8};
  grid-template-columns: ${({ columns = 3 }) => `repeat(${columns}, 1fr)`};
`

export const PeriodItem = styled.li``

const ITEM_HEIGHT = sizeToDimension.md

interface ItemButtonProps extends Themable {
  active?: boolean
  disabled?: boolean
}

export const ItemButton = styled.button<ItemButtonProps>`
  display: flex;
  opacity: ${({ disabled }) => (disabled ? 0.2 : 1)};
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${ITEM_HEIGHT}px;
  padding: ${Spacing.S8} ${Spacing.S8};
  border: none;
  border-radius: ${ITEM_HEIGHT / 2}px;
  background-color: ${({ active }) => (active ? Color.Lavender500 : Color.White)};
  color: ${({ active, theme }) => (active ? Color.White : theme.ds.colors.base.textPrimary)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'default')};
  user-select: none;
  appearance: none;
  ${getDefaultTransition('background-color')};

  ${({ active, disabled, theme }) =>
    !active &&
    !disabled &&
    css`
      cursor: pointer;

      &:hover {
        background-color: ${theme.ds.colors.base.textPrimary};
        color: ${Color.White};
      }
    `}
`

export const ImagePlaceholderWrapper = styled.figure`
  display: flex;
  margin: auto;
`

export const ImagePlaceholder = styled.img`
  width: 160px;
  height: 152px;
`
